/* eslint object-shorthand: 0 */

import i18n from 'i18next';
import moment from 'moment';
import LanguageDetector from 'i18next-browser-languagedetector';
import detectBrowserLanguage from 'detect-browser-language';

//import en from './locale/en.js';
import zh_CN from './locale/zh_CN.js';
import zh_HK from './locale/zh_HK.js';
import da_DK from './locale/da_DK.js';
import nl_NL from './locale/nl_NL.js';
import en_AU from './locale/en_AU.js';
import en_CA from './locale/en_CA.js';
import fr_CA from './locale/fr_CA.js';
import fr_FR from './locale/fr_FR.js';
import de_DE from './locale/de_DE.js';
import hi_IN from './locale/hi_IN.js';
import it_IT from './locale/it_IT.js';
import pt_BR from './locale/pt_BR.js';
import es_419 from './locale/es_419.js';
import sv_SE from './locale/sv_SE.js';
import tl_PH from './locale/tl_PH.js';
import th_TH from './locale/th_TH.js';
import tr_TR from './locale/tr_TR.js';
import vi from './locale/vi.js';

const defaultLocale = 'en-CA';

i18n
    .use(LanguageDetector)
    .init({
        interpolation: {
            prefix: '%{',
            suffix: '}',
            escapeValue: false,
        },
        whitelist: ['en-CA', 'en-AU', 'fr-CA', 'fr', 'es-419', 'es', 'vi', 'pt-BR', 'de', 'ti', 'th', 'zh', 'zh-CN', 'da', 'da-DK', 'sv', 'sv-SE', 'fr-FR', 'nl-NL', 'nl', 'it-IT', 'it', 'tl', 'tl_PH', 'hi-IN', 'tr-TR', 'tr-TK'],
        fallbackLng: defaultLocale,
        lng: detectBrowserLanguage(),
        resources: {
            'fr-CA': { translation: fr_CA },
            'fr': { translation: fr_FR },
            'fr-US': { translation: fr_FR },
            'fr-FR': { translation: fr_FR },
            'en-CA': { translation: en_CA },
            'en-AU': { translation: en_AU },
            'es-419': { translation: es_419 },
            'es-CL': { translation: es_419 },
            'es-CO': { translation: es_419 },
            'es-CR': { translation: es_419 },
            'es-HN': { translation: es_419 },
            'es-MX': { translation: es_419 },
            'es-PE': { translation: es_419 },
            'es-US': { translation: es_419 },
            'es-UY': { translation: es_419 },
            'es-VE': { translation: es_419 },
            'es': { translation: es_419 },
            'es_CA': { translation: es_419 },
            'vi': { translation: vi },
            'vi-VI': { translation: vi },
            'vi-US': { translation: vi },
            'vi-CA': { translation: vi },
            'vi-VN': { translation: vi },
            'pt-BR': { translation: pt_BR },
            'pt-US': { translation: pt_BR },
            'pt-CA': { translation: pt_BR },
            'de-AY': { translation: de_DE },
            'de-LI': { translation: de_DE },
            'de-LU': { translation: de_DE },
            'de': { translation: de_DE },
            'de-CH': { translation: de_DE },
            'de-DE': { translation: de_DE },
            'de-CA': { translation: de_DE },
            'de-US': { translation: de_DE },
            'ti': { translation: th_TH },
            'th': { translation: th_TH },
            'th-TH': { translation: th_TH },
            'th-CA': { translation: th_TH },
            'th-US': { translation: th_TH },
            'zh-HK': { translation: zh_HK },
            'zh-CN': { translation: zh_CN },
            'zh-SG': { translation: zh_CN },
            'zh-TW': { translation: zh_HK },
            'zh-Hans-US': { translation: zh_CN },
            'zh-Hans-CN': { translation: zh_CN },
            'zh-Hans-CA': { translation: zh_CN },
            'zh-CA': { translation: zh_CN },
            'zh-US': { translation: zh_CN },
            'da': { translation: da_DK },
            'da-DK': { translation: da_DK },
            'da-CA': { translation: da_DK },
            'da-US': { translation: da_DK },
            'sv': { translation: sv_SE },
            'sv-SE': { translation: sv_SE },
            'sv-CA': { translation: sv_SE },
            'sv-US': { translation: sv_SE },
            'nl-CA': { translation: nl_NL },
            'nl-NL': { translation: nl_NL },
            'nl-US': { translation: nl_NL },
            'it-CA': { translation: it_IT },
            'it-IT': { translation: it_IT },
            'it-US': { translation: it_IT },
            'tl-PH': { translation: tl_PH },
            'tl-CA': { translation: tl_PH },
            'tl-US': { translation: tl_PH },
            'hi-IN': { translation: hi_IN },
            'hi-CA': { translation: hi_IN },
            'hi-US': { translation: hi_IN },
            'tr-TR': { translation: tr_TR },
            'tr-TK': { translation: tr_TR },
            'tr-CA': { translation: tr_TR },
            'tr-US': { translation: tr_TR },
        },
        react: {
            wait: true,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        }
    });

i18n.acceptLanguage = () => {
    i18n.language.replace('-', '_');

    if (i18n.currentLocale().includes('hi')) {
        moment.updateLocale('hi', {
            postformat: function (string) {
                return string;
            }
        });
    }
};

i18n.currentLocale = () => i18n.language;

export default i18n;